import * as apiLib from './api';

export const login = async ({ loginType, accountAlias, loginId, loginPw }) => {
  try {
    const data = {
      loginType: loginType,
      accountAlias: accountAlias,
      loginId: loginId,
      loginPw: loginPw,
    };

    const result = await apiLib.fetchArchiveApi('/auth/create-token', data);
    if (result.resultFlag) {
      return { ...result.loginInfo, accessToken: result.accessToken };
    } else {
      throw Object.assign(new Error('login error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const token = async ({ accessToken }) => {
  try {
    const data = {
      accessToken: accessToken,
    };

    const result = await apiLib.fetchArchiveApi('/auth/confirm-token', data);
    if (result.resultFlag) {
      return { ...result.loginInfo, accessToken: accessToken };
    } else {
      throw Object.assign(new Error('token error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const kraftonToken = async ({ loginType, ssoToken }) => {
  try {
    const data = {
      loginType: loginType,
      ssoToken: ssoToken,
    };

    const result = await apiLib.fetchArchiveApi('/krafton/sso', data);
    if (result.resultFlag) {
      return { ...result.loginInfo, accessToken: result.accessToken };
    } else {
      throw Object.assign(new Error('token error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};
